import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { hrmsGetRequest, hrmsPostRequest, hrmsUpdateRequest, hrmsDeleteRequest } from "../services/index";

const API_URL = "/api/ObservationEvaluation";

export const createObservationEvaluation = createAsyncThunk(
  "observationEvaluation/create",
  async (data, { rejectWithValue }) => {
    try {
      const response = await hrmsPostRequest(`${API_URL}/add`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const fetchObservationEvaluationsByTeacher = createAsyncThunk(
  "observationEvaluation/fetchByTeacher",
  async (teacherEmail, { rejectWithValue }) => {
    try {
      const response = await hrmsGetRequest(`${API_URL}/teacher/${teacherEmail}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const fetchObservationEvaluationById = createAsyncThunk(
  "observationEvaluation/fetchById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await hrmsGetRequest(`${API_URL}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const fetchAllObservationEvaluations = createAsyncThunk(
  "observationEvaluation/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await hrmsGetRequest(API_URL);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updateObservationEvaluation = createAsyncThunk(
  "observationEvaluation/update",
  async ({ id, updateData }, { rejectWithValue }) => {
    try {
      const response = await hrmsUpdateRequest(`${API_URL}/${id}`, updateData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deleteObservationEvaluation = createAsyncThunk(
  "observationEvaluation/delete",
  async (id, { rejectWithValue }) => {
    try {
      await hrmsDeleteRequest(`${API_URL}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const observationEvaluationSlice = createSlice({
  name: "observationEvaluation",
  initialState: {
    evaluations: [],
    currentEvaluation: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearCurrentEvaluation: (state) => {
      state.currentEvaluation = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createObservationEvaluation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createObservationEvaluation.fulfilled, (state, action) => {
        state.loading = false;
        state.evaluations.unshift(action.payload);
      })
      .addCase(createObservationEvaluation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(fetchObservationEvaluationsByTeacher.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchObservationEvaluationsByTeacher.fulfilled, (state, action) => {
        state.loading = false;
        state.evaluations = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchObservationEvaluationsByTeacher.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(fetchObservationEvaluationById.fulfilled, (state, action) => {
        state.currentEvaluation = action.payload;
      });
    builder
      .addCase(deleteObservationEvaluation.fulfilled, (state, action) => {
        state.evaluations = state.evaluations.filter((e) => e.id !== action.payload);
        if (state.currentEvaluation?.id === action.payload) state.currentEvaluation = null;
      });
  },
});

export const { clearError, clearCurrentEvaluation } = observationEvaluationSlice.actions;
export default observationEvaluationSlice.reducer;
